import { render } from "./ModalRegister.vue?vue&type=template&id=2b5a5a06"
import script from "./ModalRegister.vue?vue&type=script&lang=js"
export * from "./ModalRegister.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__